import React from 'react'

export default function Footer() {
    return (
        <div>
            <footer className='theFooter'>
                <p>Made By: Alexis , PJ, Chris</p>

        </footer>
        </div>
    )
}
